import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaCheck, FaTrash, FaBars } from "react-icons/fa";
import { TbFilterPause } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import Search from "../../common/Search";
import NotificationFilters from "../../common/FilterTabs";
import {
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  deleteNotification,
  getUnreadCount,
} from "../../redux/services/notificatrion/notification.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { DeleteEnquiry } from "../../redux/services/EnquriesService/enquries.Services";

function NotificationList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";

  const [notification, setNotification] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalPages, setTotalPages] = useState(1);
  const [unreadCount, setUnreadCount] = useState(0);
  const [activeFilter, setActiveFilter] = useState("all"); 
  const [showActions, setShowActions] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  // Search
  const [search, setSearch] = useState("");

  // Filter form state
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({
    type: "",
    unread_only: "",
    from_date: "",
    to_date: "",
  });

  // Counts
  const [counts, setCounts] = useState({
    all: 0,
    unread: 0,
    read: 0,
  });

  /* ---------------- RESPONSIVE ---------------- */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      if (!mobile) setShowActions(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
const resolveUnreadOnly = (tab = activeFilter, f = filters) => {
  if (f.unread_only === "1" || f.unread_only === 1) return 1;
  if (f.unread_only === "0" || f.unread_only === 0) return 0;
  if (tab === "unread") return 1;
  return 0;
};
  const fetchNotifications = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) setInitialLoading(true);
      else setTableLoading(true);
      const payload = {
        page: pageNo,
        per_page: limit,
        search: search || "",
        type: filters.type || "",
          unread_only: resolveUnreadOnly(activeFilter, filters),
      };
      const [listRes, countRes] = await Promise.all([
        getNotifications(payload),
        getUnreadCount({}),
      ]);
      const list =
        listRes?.data?.notifications ||
        listRes?.data ||
        listRes?.notifications ||
        [];
      setNotification(Array.isArray(list) ? list : []);
      setPage(listRes?.current_page || pageNo);
      setTotalPages(listRes?.last_page || 1);
      const count =
        countRes?.data?.count || countRes?.count || countRes?.data || 0;
      setUnreadCount(typeof count === "number" ? count : 0);

      setCounts({
        all: listRes?.total || list.length,
        unread: count || 0,
        read:
          (listRes?.total || list.length) -
          (typeof count === "number" ? count : 0),
      });

      applyClientFilter(list, activeFilter);
    } catch (err) {
      console.log(err);
      errorToast("Failed to load notifications");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };
 const applyClientFilter = (data, filterType) => {
  let filtered = [...data];
  if (filterType === "read") {
    filtered = filtered.filter((n) => n.read_at);
  } else if (filterType === "unread") {
    filtered = filtered.filter((n) => !n.read_at);
  }
  setFilteredNotifications(filtered);
};

  useEffect(() => {
    fetchNotifications(1, true);
  }, [limit]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchNotifications(1, false);
    }, 500);
    return () => clearTimeout(delay);
  }, [search, activeFilter, filters]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchNotifications(newPage, false);
    }
  };

  const handleFilterClick = (filterType) => {
    setActiveFilter(filterType);
    applyClientFilter(notification, filterType);
    setPage(1);
    fetchNotifications(1, false);
  };

  const handleMarkRead = async (id) => {
    try {
      const res = await markNotificationRead({ notification_id: String(id) });
      successToast(res?.message || "Marked as read");
      fetchNotifications(page, false);
    } catch (err) {
      errorToast(err?.response?.data?.message || "Failed");
    }

  };
  const handleMarkAll = async () => {
    try {
      const res = await markAllNotificationsRead();
      successToast(res?.message || "All marked as read");
      fetchNotifications(page, false);
    } catch (err) {
      errorToast(err?.response?.data?.message || "Failed");
    }
  };


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const handleApplyFilters = () => {
    setPage(1);
    fetchNotifications(1, false);
    successToast("Filters applied");
  };

  const handleResetFilters = () => {
    setFilters({
      type: "",
      unread_only: "",
      from_date: "",
      to_date: "",
    });
    setSearch("");
    setActiveFilter("all");
    fetchNotifications(1, false);
    successToast("Filters reset");
  };

  const handleToggleFilter = () => setShowFilter((p) => !p);

  const tabs = [
    {
      label: `All Notifications (${counts.all || 0})`,
      className: "btn-all",
      value: "all",
    },
    {
      label: `Unread (${counts.unread || 0})`,
      className: "btn-interested",
      value: "unread",
    },
    {
      label: `Read (${counts.read || 0})`,
      className: "btn-not-interested",
      value: "read",
    },
  ];

  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* ==================== HEADER ==================== */}
      <div className="pageheaderall position-relative d-md-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">All Notifications</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>Notification List</span>
              </nav>
            </div>
          </div>

          {isMobile && (
            <button
              className="btn btn-primary"
              onClick={() => setShowActions(!showActions)}
            >
              <TbFilterPause />
            </button>
          )}
        </div>

        {/* Desktop Buttons */}
        {!isMobile && (
          <div className="d-flex align-items-center w-100 gap-2 justify-content-end">
            {/* Search */}
            <div style={{ minWidth: 240 }}>
              <Search
                search={search}
                onSearch={setSearch}
                placeholder="Search notifications..."
              />
            </div>

            {/* Tabs */}
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                  }`}
                onClick={() => handleFilterClick(tab.value)}
              >
                {tab.label}
              </button>
            ))}

            {/* Filter button */}
            <button
              className="lead-btn btn-filter"
              onClick={handleToggleFilter}
            >
              <i className="fas fa-filter me-1"></i>
              {showFilter ? "Hide Filter" : "Filter"}
            </button>

            {/* Mark all read */}
            {unreadCount > 0 && (
              <button className="lead-btn btn-add" onClick={handleMarkAll}>
                Mark All Read
              </button>
            )}
          </div>
        )}
      </div>

      {/* ==================== MOBILE BOTTOM SHEET ==================== */}
      {isMobile && (
        <>
          <div
            className={`menu-overlay ${showActions ? "show" : ""}`}
            onClick={() => setShowActions(false)}
          ></div>

          <div
            className={`dorpdownloaddatabutton ${showActions ? "active" : ""
              }`}
          >
            <div style={{ padding: "0 4px 12px" }}>
              <Search
                search={search}
                onSearch={setSearch}
                placeholder="Search notifications..."
              />
            </div>

            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                  }`}
                onClick={() => {
                  handleFilterClick(tab.value);
                  setShowActions(false);
                }}
              >
                {tab.label}
              </button>
            ))}

            <button
              className="lead-btn btn-filter"
              onClick={() => {
                handleToggleFilter();
                setShowActions(false);
              }}
            >
              <i className="fas fa-filter me-1"></i>
              {showFilter ? "Hide Filter" : "Filter"}
            </button>

            {unreadCount > 0 && (
              <button
                className="lead-btn btn-add"
                onClick={() => {
                  handleMarkAll();
                  setShowActions(false);
                }}
              >
                Mark All Read
              </button>
            )}
          </div>
        </>
      )}

      {/* ==================== FILTER FORM ==================== */}
      <NotificationFilters
        showFilter={showFilter}
        filters={filters}
        onFilterChange={handleFilterChange}
        onApplyFilters={handleApplyFilters}
        onResetFilters={handleResetFilters}
        onToggleFilter={handleToggleFilter}
      />

      {/* ==================== MAIN ==================== */}
      <div className="main_page">
        {totalPages > 1 && (
          <div className="d-flex justify-content-end mb-3">
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : filteredNotifications.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      No notifications found
                    </td>
                  </tr>
                ) : (
                  filteredNotifications.map((item, index) => {
                    const id = item._id || item.id;
                    return (
                      <tr key={id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td className="fw-semibold">
                          {item.title || "Notification"}
                        </td>
                        <td
                          style={{
                            maxWidth: 320,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={item.message}
                        >
                          {item.message || "—"}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {item.createdAt
                            ? new Date(item.createdAt).toLocaleString()
                            : "—"}
                        </td>
                        <td>
                          <span
                            className={`crm-status-badge ${item.read_at
                              ? "crm-status-completed"
                              : "crm-status-busy"
                              }`}
                          >
                            {item.read_at ? "Read" : "Unread"}
                          </span>
                        </td>
                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            <button
                              className="st-action-btn st-view-btn"
                              title="View"
                              onClick={() =>
                                dispatch(
                                  openModal({
                                    type: "view-notification",
                                    title: "View Notification",
                                    data: item,
                                  })
                                )
                              }
                            >
                              <FaEye />
                            </button>
                            {!item.isRead && (
                              <button
                                className="st-action-btn st-edit-btn"
                                title="Mark as read"
                                onClick={() => handleMarkRead(item.notification_id || item.id || item._id)}
                              >
                                <FaCheck />
                              </button>
                            )}
                            {role === "admin" && (
                              <button
                                className="st-action-btn st-edit-btn"
                                onClick={() =>
                                  dispatch(
                                    openModal({
                                      type: "delete-notification",
                                      title: "Delete Notification",
                                      data: {
                                        notification_id: item.id,
                                        name: item.name,
                                        deleteFunction: deleteNotification,
                                        refreshData: fetchNotifications,
                                      },
                                    })
                                  )
                                }
                              >
                                <FaTrash />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationList;